import styled from "styled-components";
import { Input as InputAntd } from "antd";
import { Colors } from "configs";

export const StyledInput = styled(InputAntd)`
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  box-shadow: none !important;
  padding: 15px;

  .ant-input-prefix {
    color: ${Colors.primary};
    font-size: 25px;
    padding-right: 20px;
  }

  :focus,
  :hover {
    border-color: ${Colors.primary};
  }
`;

export const StyledInputPassword = styled(InputAntd.Password)`
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  box-shadow: none !important;
  padding: 15px;

  .ant-input-prefix {
    color: ${Colors.primary};
    font-size: 25px;
    padding-right: 20px;
  }
  .ant-input-suffix {
    font-size: 25px;
    > span {
      color: ${Colors.primary};
    }
  }

  :focus,
  :hover {
    border-color: ${Colors.primary};
  }
`;
